// HomePage/index.js
import React from 'react';

import { useAuth0 } from '../../react-auth0-spa';
import { userRoles } from '../../constants';
import BranchesPage from '../BranchesPage';
import AdminPage from '../../containers/AdminPage';

function HomePage(props) {
  const { loading, user } = useAuth0();
  const { fetchUserDetails, userRole } = props;
  React.useEffect(() => {
    fetchUserDetails(user.email);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (loading || !user || !userRole) {
    return <div>Loading...</div>;
  }

  if (userRole === userRoles.BRANCH) {
    return <BranchesPage />;
  } else if (
    userRole === userRoles.ADMIN ||
    userRole === userRoles.SUPER_ADMIN ||
    userRole === userRoles.ADMIN_COMPANY
  ) {
    return <AdminPage />;
  }
}

HomePage.propTypes = {
  // describe the component's prop types here
};

HomePage.defaultProps = {
  // assign default props to the component here
};

export default HomePage;
